// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3KpLj","topBottomGutter":"Layout_topBottomGutter__3BXZK"};